import React, { useState, useEffect, useRef, useCallback, memo } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import Header from "../components/Frontend/Header";
import Footer from "../components/Frontend/Footer";
import FameWallPte from "../components/Frontend/FameWallPte";
import Testimonial from "../components/Frontend/Testimonial";
import WhyLove from "../components/Frontend/WhyLove";
import VideoTestimonial from "../components/Frontend/VideoNaatiTestimonial";
import NaatiTut from "../components/Frontend/NaatiTut";
import { store } from "store/index";
import { setAlert } from "action/index.js";
import API from "api.js";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import PhoneInputField from "components/Inputs/PhoneInputField";
import { Slide } from "react-toastify";
import SuccessfulStudent from "../components/Frontend/Sliders/SuccessfulStudent";
import TrainingOnline from "../components/Frontend/Sliders/TrainingOnline";
import ReusableHomePageSlider from "./ReusableHomePageSlider";
import Immigration from "../assets/images/public-pages/NaatiSolutions.svg";
import ExpertTrainers from "../assets/images/public-pages/Expert-Trainers.svg";
import OnlineFlexibility from "../assets/images/public-pages/Online-Flexibility.svg";
import ProvenSuccess from "../assets/images/public-pages/Proven-Success.svg";
import PersonalizedFeedback from "../assets/images/public-pages/Personalized-Feedback.svg";
import ComprehensiveResources from "../assets/images/public-pages/Comprehensive-Resources.svg";
import NAATICCLIcon from "../assets/images/public-pages/NAATICCLIcon.png";
import PlatoformIcon from "../assets/images/public-pages/PlatoformIcon.png";
import RealTImeIcon from "../assets/images/public-pages/RealTImeIcon.png"
import MobileIcon from "../assets/images/public-pages/MobileIcon.png"
import Strategies from "../assets/images/public-pages/Strategies.svg"
import SkillAreas from "components/PublicPagesReusable/SkillAreas";
import ListeningIcon from "../assets/images/public-pages/Listening-icon.png";
import TranslationIcon from "../assets/images/public-pages/Translation-icon.png";
import TimeIcon from "../assets/images/public-pages/Time-icon.png";
import FeeIcon from "../assets/images/public-pages/FeeIcon.png";
import TestEnvironmentIcon from "../assets/images/public-pages/TestEnvironmentIcon.png";
import DiscussionIcon from "../assets/images/public-pages/DiscussionIcon.png";
import QuestionsIcon from "../assets/images/public-pages/QuestionsIcon.png";
import SupportIcon from "../assets/images/public-pages/SupportIcon.png";
import ResourceIcon from "../assets/images/public-pages/ResourceIcon.png";
import MaterialsIcon from "../assets/images/public-pages/MaterialsIcon.png";
import HighestIcon from "../assets/images/public-pages/HighestIcon.png";
import ExperiencedIcon from "../assets/images/public-pages/ExperiencedIcon.png";
import BuildingIcon from "../assets/images/public-pages/BuildingIcon.png";
import DollarIcon from "../assets/images/public-pages/DollarIcon.png";
import UserIcon from "../assets/images/public-pages/UserIcon.png";
import bannerImage from "../assets/images/public-pages/New-Public-banner.webp"
import ButtonComp from "components/PublicPagesReusable/ButtonComp";
import ContentImageSection from "components/PublicPagesReusable/ContentImageSection";
import AppPromoSection from "components/PublicPagesReusable/AppPromoSection";
import ExamSkillsSection from "components/PublicPagesReusable/ExamSkillsSection";
import ComparisonSection from "components/PublicPagesReusable/ComparisionSection";
import ImmigrationSection from "components/PublicPagesReusable/ImmigrationSection";
import TestSection from "components/PublicPagesReusable/TestSection";
import AdvantageSection from "components/PublicPagesReusable/AdvantageSection";
import PricingSection from "components/PublicPagesReusable/PricingSection";
import AiPower from "components/PublicPagesReusable/AiPowerSection";
import TestimonialSection from "components/PublicPagesReusable/TestimonialSection";
import PteAppBanner from "components/PublicPagesReusable/PteAppBanner";
import FaqSection from "components/PublicPagesReusable/FaqSection";
import BannerHeader from "components/PublicPagesReusable/BannerHeader";
import InfoSection from "components/PublicPagesReusable/InfoSection";
import AppBannerCustom from "components/PublicPagesReusable/AppBannerCustom";

const NaatiOnlineCoaching = memo(() => {
  // State declarations
  const [homePage, setHomePage] = useState(false);
  const [list, setList] = useState([]);
  const [sliderStyles, setSliderStyles] = useState({
    marginLeft: "0px",
    width: "100%",
  });
  const [isActive, setIsActive] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [readMoreFlag, setReadMoreFlag] = useState(false);
  const [course, setCourse] = useState("NAATI CCL Online");
  const [query, setQuery] = useState("");
  const [lang, setLang] = useState("Hindi");
  const [flag, setFlag] = useState(false);
  const [loginLock, setLoginLock] = useState(false);
  const [forceUpdateKey, setForceUpdateKey] = useState(0);
  const navigate = useNavigate();

  // Refs
  const sliderRef = useRef(null);
  const validator = useRef(new SimpleReactValidator());

  // Force re-render for validator messages
  const forceUpdate = useCallback(() => {
    setForceUpdateKey((prev) => prev + 1);
  }, []);

  // Lifecycle: componentDidMount
  useEffect(() => {
    ReactGA.initialize("UA-157984080-1");
    ReactGA.pageview(window.location.pathname + window.location.search);
    
    // ReactPixel.init("197333187452630");
    // ReactPixel.pageView();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Event handlers
  const handleClick = useCallback(() => {
    setIsActive((prev) => !prev);
  }, []);

  const changeInput = useCallback((e) => {
    const { name, value } = e.target;
    switch (name) {
      case "name":
        setName(value);
        break;
      case "email":
        setEmail(value);
        break;
      case "phone":
        setPhone(value);
        break;
      case "course":
        setCourse(value);
        break;
      case "query":
        setQuery(value);
        break;
      case "lang":
        setLang(value);
        break;
      default:
        break;
    }
  }, []);

  const changeReadMore = useCallback(() => {
    setReadMoreFlag((prev) => !prev);
  }, []);

  const hitApi = useCallback(async () => {
    if (loginLock) return;

    if (!validator.current.allValid()) {
      validator.current.showMessages();
      forceUpdate();
      return;
    }

    setLoginLock(true);

    var bodyFormData = new FormData();
    bodyFormData.set("email", email);
    bodyFormData.set("name", name);
    bodyFormData.set("phone", phone);
    bodyFormData.set(
      "message",
      "<b>Language:</b> " +
        lang +
        "<br/><b>Course:</b> " +
        course +
        "<br/><b>Query:</b> " +
        query,
    );
    bodyFormData.set(
      "data",
      "email: " +
        email +
        ",name: " +
        name +
        ",phone: " +
        phone +
        ",course: " +
        course +
        ",query: " +
        query,
    );
    bodyFormData.set("page", "NAATI Online coaching");
    let res = null;
    try {
      res = await API({
        method: "POST",
        url: "sendOnlinePte",
        data: bodyFormData,
      });
    } catch (error) {}
    console.log(res);
    if (res?.status === 200) {
      store.dispatch(
        setAlert({ flag: true, type: 1, message: res.data.message }),
      );
      setName("");
      setEmail("");
      setPhone("");
      setCourse("PTE On-Campus");
      setQuery("");
      setLoginLock(false);
      setFlag(true);
    } else {
      setLoginLock(false);
    }
  }, [loginLock, email, name, phone, lang, course, query, forceUpdate]);

  const submitForm = useCallback(
    (e) => {
      e.preventDefault();
      hitApi();
    },
    [hitApi],
  );

  // Handle phone change (if PhoneInputField expects a specific handler)
  const handlePhoneChange = useCallback((value) => {
    setPhone(value);
  }, []);

  // Render redirect if flag is true
  if (flag) {
    return <Navigate to="/thank-you" replace />;
  }

  // Slider settings
  const customslider = {
    dots: false,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
  };
  const pteSlider = {
    dots: true,
    arrows: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };
  const CardsSlider = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    adaptiveHeight: true,
    autoplaySpeed: 2000,
  };

  const bannerTitle = () => {
    return (
      <h1 className="FS56FW500 top-section-text">
        Professional NAATI CCL Online Coaching
        For <span className="text-success">PR Success</span>
      </h1>
    );
  };

  const subTitleSection = () => {
    return (
      <p className="sub-title text-center FS16FW500 white">
        Expert-led NAATI CCL training with flexible scheduling, personalized
        feedback, and everything you need to pass on your first attempt.
      </p>
    );
  };

  const images = [
    {
      src: "/images/web-new-images/emojis/Updated/Score01.png",
      alt: "score-1",
    },
    {
      src: "/images/web-new-images/emojis/Updated/Score02.png",
      alt: "score-2",
    },
    {
      src: "/images/web-new-images/emojis/Updated/Score03.png",
      alt: "score-3",
    },
    {
      src: "/images/web-new-images/emojis/Updated/Score04.png",
      alt: "score-4",
    },
    {
      src: "/images/web-new-images/emojis/Updated/Score05.png",
      alt: "score-5",
    },
    {
      src: "/images/web-new-images/emojis/Updated/Score06.png",
      alt: "score-6",
    },
   {
    src: "/images/web-new-images/emojis/Updated/Score07.jpg",
    alt: "score-7",
  },
  {
    src: "/images/web-new-images/emojis/Updated/Score08.jpg",
    alt: "score-8",
  },
  {
    src: "/images/web-new-images/emojis/Updated/Score09.jpg",
    alt: "score-9",
  },
  {
    src: "/images/web-new-images/emojis/Updated/Score10.jpg",
    alt: "score-10",
  },    
  ];

  const heroDescriptionSection = () => {
    return (<p className="sub-title text-center FS16FW500">
      Achieve your goal of passing the NAATI CCL exam with personalized NAATI CCL coaching, designed for <br/> aspiring immigrants, students, and language learners.<br/><br/> Gain confidence in your translation and interpretation skills, earn extra points for Australian PR, and<br/> unlock your potential with our comprehensive NAATI CCL online course training program.
    </p>)
  }
  const skillAreaTitle = () => {
    return (
      <p className="top-section-text mb-4 white FS40FW600">
        <span className="text-success FS40FW600">Why Take NAATI CCL</span><br/>Training Online?
      </p>
    )
  }

  const preprationWorkTitle = () => {
    return (
      <p className="top-section-text mb-4 white FS40FW600">
        How Our NAATI
        <span className="text-success FS40FW600">{" "}CCL Online Coaching</span><br/>Preparation Works
      </p>
    )
  }
 const preprationWorkCards = [
      {
        title: "Orientation Class",
        text: "Learn the basics of NAATI CCL through our NAATI CCL training. Our experts guide you on how to gain maximum scores in the test.",
        color: "#0286FF",
        img: '/images/web-new-images/emojis/Updated/WhiteGlobe.svg',
        badge: "Step 1"
      },
      {
        title: "Live Practice Sessions",
        text: "Our NAATI CCL coaching trainers monitor your performance and provide feedback on your dialogues and vocabulary usage.",
        color: "#0286FF",
        img: '/images/web-new-images/emojis/Updated/WhiteGlobe.svg',
        badge: "Step 2"
      },
      {
        title: "CCL Practice App Access",
        text: "Get access to our CCL app for excellent listening practice through our NAATI online course with audio recordings and sample answers.",
        color: "#0286FF",
        img: '/images/web-new-images/emojis/Updated/WhiteGlobe.svg',
        badge: "Step 3"
      },
      {
        title: "Weekly Mock Tests",
        text: "Take weekly tests through our NAATI CCL Online Classes and receive full scorecards with your scores and areas of improvement.",
        color: "#0286FF",
        img: '/images/web-new-images/emojis/Updated/WhiteGlobe.svg',
        badge: "Step 4"
      },
      {
        title: "Final Consultation",
        text: "Once you complete our NAATI CCL online course, our experts advise how much more practice you need before booking your exam.",
        color: "#0286FF",
        img: '/images/web-new-images/emojis/Updated/WhiteGlobe.svg',
        badge: "Step 5"
      },
    ];
   const lifestyleCards = [
      {
        title: "Expert Trainers",
        text: "Learn from experienced professionals through our NAATI online course who understand the test requirements inside out.",
        color: "#48A75C",
        img: ExpertTrainers
      },
      {
        title: "Personalized Feedback",
        text: "Receive tailored insights through our NAATI CCL coaching to identify your weaknesses and improve your performance.",
        color: "#0286FF",
        img: PersonalizedFeedback
      },
      {
        title: "Online Flexibility",
        text: "Study anytime, anywhere with our NAATI CCL Online Classes learning schedule that fits your lifestyle.",
        color: "#7F56D9",
        img: OnlineFlexibility
      },
      {
        title: "Comprehensive Resources",
        text: "Access the latest vocabulary lists, practice dialogues, and mock tests.",
        color: "#FFB02C",
        img: ComprehensiveResources
      },
      {
        title: "Proven Success",
        text: "Join thousands of successful students who earned their PR points with our NAATI CCL training centre coaching.",
        color: "#FFB02C",
        img: ProvenSuccess
      },
    ];

      const contentSection = () => {
    return (
   <p className="top-section-text FS40FW600">
    Overcome Your Challenges With Our {" "}
   <span className="text-success FS40FW600">Tailored Online Solutions </span><br/>
    </p>
    )
  }
  const skillAreaTitle2 = () => {
    return (
      <p className="top-section-text FS40FW600">
        Overcome Your Challenges With Our <br/>
        <span className="text-success FS40FW600">
          Tailored Online Solutions
        </span>
      </p>
    );
  };

  const styleCards = [
    {
      title: "Online Practice Platform",
      text: "Learn from anywhere with our easy-to-use NAATI online course digital tools.",
      color: "#141414",
      img: PlatoformIcon
    },
    {
      title: "Real-Time Mock Tests",
      text: "Simulate the actual exam environment through our NAATI CCL coaching platform to boost your readiness.",
      color: "#141414",
      img: RealTImeIcon
    },
    {
      title: "NAATI CCL Mobile App",
      text: "Practice vocabulary and dialogues on the go, anytime with our NAATI CCL Online Classes mobile application.",
      color: "#141414",
      img: MobileIcon
    },
    {
      title: "NAATI CCL Online Coaching",
      text: "Get one-on-one guidance from experienced trainers.",
      color: "#141414",
      img: NAATICCLIcon
    },
    // {
    //   title: "Proven Strategies",
    //   text: "Master exam techniques to maximize your performance in each skill area.",
    //   color: "#141414",
    //   img: Strategies
    // }
  ];

  const sliderList = {
    title: "What Our <span>Students Say</span>",
    subtitle: "Real success stories from our learners",

    settings: {
      slidesToShow: 2.5,
      autoplay: true,
    },

    items: [
      {
        id: 1,
        name: "Sahida Khatun",
        location: "Tanahun, Nepal",
        description:
          "Thank you so much LA team, especially my tutor Roopali. Because of her guidance, techniques and strategies, I got my desired score. Anyone struggling to get their score I would highly recommend to join LA academy. It was my best decision to join LA.",
        image: "/images/web-new-images/new-content-slider/SahidaKhatun-demo.svg",
      },
      {
        id: 2,
        name: "Dilmeet Kingra",
        location: "Sydney, Australia",
        description:
          "I had a great experience with LA. The teachers  are knowledgeable, supportive, and explain concepts in a clear and practical way. The study materials and mock tests were very helpful. The classes improved my confidence, especially in speaking and writing. Overall, I highly recommend LA to anyone preparing for the PTE exam.t",
        image: "/images/web-new-images/new-content-slider/DilmeetKingra-demo.svg",
      },
      {
        id: 3,
        name: "Sapna Pandey Subedi",
        location: "Kathmandu, Nepal",
        description:
          "I had a great experience with Language Academy for PTE. I achieved my desired score within just 2 weeks through 1:1 sessions with Priyanka. Thank you, Priyanka and Language Academy, for your guidance and support. I highly recommend Language Academy to anyone preparing for PTE and looking for fast, effective results.",
        image: "/images/web-new-images/new-content-slider/SapnaPandey-demo.svg",
      },
      {
        id: 4,
        name: "Jay Patel",
        location: "Brisbane, Queensland, Australia",
        description:
          "I had a great experience with Language Academy. The classes helped me a lot to achieve my desired score. My tutor, Jaspreet Mam, was very supportive, patient, and knowledgeable. She explained concepts clearly, gave useful feedback, and focused on my weak areas, which really improved my confidence and performance.",
        image: "/images/web-new-images/new-content-slider/JayPatel-demo.svg",
      },
      {
        id: 5,
        name: "Ramim Rahman",
        location: "Sydney, Australia",
        description:
          "I enrolled in a 14 day PTE online course at language Academy and only attended one week of strategy classes. And another week I did 1 to 2 hrs practice. Within 15 days, I got my desired score on the first attempt. Their tricks and strategies are truly unique specially after the recent change in PTE. I highly recommend language academy PTE.",
        image: "/images/web-new-images/new-content-slider/RamimRahman-demo.svg",
      },
      {
        id: 6,
        name: "Hamza Aghariya",
        location: "Brisbane, Queensland, Australia",
        description:
          "I enrolled for NAATI CCL classes with LA 2 months ago and I have nothing but good things to say about LA academy. Mayur sir is an amazing teacher and his methods are really effective. The admin team is very friendly and flexible to suit your requirements. If you are looking to take some NAATI or PTE classes, join LA and I promise you wont regret it.",
        image: "/images/web-new-images/new-content-slider/HamzaAghariya-demo.svg",
      },
    ],
  };

    const pricingSectionData = {
    title: "Choose Your",
    highlight: "NAATI CCL Online",
    subtitle: "Coaching Plan",
    note: "Choose between our affordable NAATI course fee options:",

    plans: [
      {
        name: "Beginner",
        price: "$119",
        priceByText:'/ 2 Months',
        features: [
          { text: "Real Exam Practice Material", active: true },
          { text: "Full Vocabulary Access", active: true },
          { text: "Full Length Mock Tests", active: true },
          { text: "Last Minute Practice", active: true },
          // { text: "Unlimited full mock tests with scoring", active: true },
          // { text: "Unlimited comprehensive mock tests with scoring", active: true },
          { text: "1 Mock test with Scorecard & Feedback on Improvement", active: false },
        ],
        button: "Enroll Now",
        buttonLink: `${import.meta.env.VITE_NAATI_URL}auth/register`,
      },
      {
        name: "Pro",
        price: "$189",
        priceByText:'/ 2 Months',
        // badge: "BEST SELLER",
        features: [
          { text: "Real Exam Practice Material", active: true },
          { text: "Full Vocabulary Access", active: true },
          { text: "Full Length Mock Tests", active: true },
          { text: "Last Minute Practice", active: true },
          // { text: "Unlimited full mock tests with scoring", active: true },
          // { text: "Unlimited comprehensive mock tests with scoring", active: true },
          { text: "1 Mock test with Scorecard & Feedback on Improvement", active: true },
        ],
        button: "Enroll Now",
        buttonLink: `${import.meta.env.VITE_NAATI_URL}auth/register`,
      },
      {
        name: "Online Coaching",
        badge: "MOST POPULAR",
        highlightCard: true,
        description:
          "Get the ultimate preparation with live expert guidance.",
        features: [
          {
            title: "Live Virtual Classes",
            desc: "Join expert-led sessions focusing on each component of the exam",
          },
          {
            title: "Personalized Feedback",
            desc: "Receive detailed analysis of your performance with specific improvement strategies",
          },
          {
            title: "Direct Trainer Access",
            desc: "Get your questions answered directly by our experienced instructors",
          },
          {
            title: "Priority Support",
            desc: "Fast-track assistance whenever you face challenges in your preparation",
          },
        ],
        button: "Book Your Trial Class",
        buttonLink: `${import.meta.env.VITE_NAATI_URL}auth/register`,
      },
    ],
  };

    const faqQuestions = [
    {
      question: "How long does it take to prepare for the NAATI CCL exam with your NAATI CCL training?",
      answer: "Most students need 4-6 weeks of consistent NAATI CCL coaching preparation, but it may vary depending on your current proficiency and practice time."
    },
    {
      question: "What languages do you offer NAATI CCL online course preparation in?",
      answer: "We offer NAATI online course preparation in 12 languages: Hindi, Punjabi, Urdu, Nepali, Bangla, Tamil, Telugu, Malayalam, Gujarati, Sinhalese, Marathi and Kannada."
    },
    {
      question: "Can I reschedule my NAATI CCL Online Classes sessions?",
      answer: "Yes, we offer flexible scheduling options for our NAATI CCL online coaching to fit your availability, making online learning even more convenient."
    },
    {
      question: "How does the NAATI CCL mobile app help with NAATI CCL training centre preparation?",
      answer: "Our app includes 2000+ vocabulary words, 75 practice dialogues for each language, mock tests that simulate the real exam environment through our NAATI CCL coaching system."
    },
    {
      question: "What score do I need to pass the NAATI CCL exam?",
      answer: "You need to score a minimum of 29 out of 45 in each dialogue to pass the NAATI CCL exam successfully."
    },
    {
      question: "Do you provide practice materials for previous exam questions? ",
      answer: "Yes, we have curated over 1000+ questions from previous exams to help you practice the most commonly asked questions."
    }
  ];
  return (
    <React.Fragment>
      <Helmet>
        <title>
          NAATI CCL Coaching Classes Australia | LA Language Academy
        </title>
        <meta
          name="description"
          content="Prepare for the NAATI CCL exam with LA Language Academy's online coaching classes in Australia. Access expert guidance and practice materials to succeed."
        />
        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href={`https://www.languageacademy.com.au/naati-ccl-online-coaching`}
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@languageacademy" />
        <meta
          name="twitter:title"
          content="NAATI CCL Coaching Classes Australia | LA Language Academy"
        />
        <meta
          name="twitter:description"
          content="Prepare for the NAATI CCL exam with LA Language Academy's online coaching classes in Australia. Access expert guidance and practice materials to succeed."
        />
        <meta
          name="twitter:image"
          content={`https://www.languageacademy.com.au/images/logol.png`}
        />
        <meta name="twitter:image:alt" content="LA Language Academy Logo" />
        <meta
          property="og:url"
          content={`https://www.languageacademy.com.au/naati-ccl-online-coaching`}
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="NAATI CCL Coaching Classes Australia | LA Language Academy"
        />
        <meta
          property="og:description"
          content="Prepare for the NAATI CCL exam with LA Language Academy's online coaching classes in Australia. Access expert guidance and practice materials to succeed."
        />
        <meta
          property="og:image"
          content={`https://www.languageacademy.com.au/images/logol.png`}
        />
        <meta property="og:image:alt" content="LA Language Academy Logo" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
      </Helmet>
      <div className="new-design">
        <Header />
        <BannerHeader
          title={bannerTitle}
          subTitle={subTitleSection}
          backgroundColor="#182A4F"
          textColor="white"
          btnLink={`${import.meta.env.VITE_NAATI_URL}auth/register`}
          middleSection={() => {
            return (
              <div
                className="banner-img-wrapper"
                style={{ paddingBottom: "232px" }}
              >
                <img
                  className="banner-img"
                  src={bannerImage}
                  alt="LA"
                />
              </div>
            );
          }}
        />
        <div className="iframe-video-outer position-relative d-none">
          <div className="banner-img-wrapper"></div>
          <img
            className="emoji1 position-absolute"
            src="/images/web-new-images/emojis/emoji-4.png"
            alt="LA"
          />
          <img
            className="emoji2 position-absolute"
            src="/images/web-new-images/emojis/emoji-2.png"
            alt="LA"
          />
          <img
            className="emoji3 position-absolute"
            src="/images/web-new-images/emojis/emoji-3.png"
            alt="LA"
          />
          <img
            className="emoji4 position-absolute"
            src="/images/web-new-images/emojis/emoji-1.png"
            alt="LA"
          />
        </div>

        <div className="fame-wall">
          <ReusableHomePageSlider images={images} />
        </div>
        <div className="d-flex align-items-center gap-3 flex-column pb-4">
          {heroDescriptionSection()}
          <ButtonComp
            link={`${import.meta.env.VITE_NAATI_URL}auth/register`}
            btnText={"Enroll In Our Program Today"}
          />
        </div>
        <InfoSection
          title="What Is The NAATI CCL Exam?"
          subtitle="Your Gateway To Australian Permanent Residency"
          description="The NAATI Credentialled Community Language (CCL) exam is a critical test that evaluates your ability to interpret and translate between English and your chosen language. Passing this test can earn you an extra five points toward your Australian Permanent Residency (PR)."
          buttonText="Start Your NAATI CCL Prep Journey Now"
          buttonAction={() => window.location.href = `${import.meta.env.VITE_NAATI_URL}auth/register`}
          image="/images/web-new-images//NaatiOnline.svg"
          imageCaption="The exam consists of two dialogue recordings, each presenting a conversation between an English speaker and a speaker in your specific language. Your task is to interpret and translate accurately while demonstrating confidence and cultural understanding."
          rightTitle="NAATI CCL Test Pattern"
          rightDescription="The NAATI CCL test assesses your language skills at a community level through recorded conversation dialogues:"
          features={[
            "<strong>Two recordings</strong> with dialogues of 300 words each",
            "<strong>30 minutes</strong> total time to complete both recordings",
            "<strong>Segments of 35 words</strong> each carrying 45 marks",
            "<strong>Minimum score of 29 </strong> required in each dialogue to pass successfully",
            "<strong>Available in 12 languages:</strong> Hindi, Punjabi, Urdu, Nepali, Bangla, Tamil, Telugu, Malayalam, Gujarati, Sinhalese, Kannada and Marathi",
          ]}
          footerText="By combining the right resources, expert coaching, and regular practice, you'll not only ace the test but also gain essential skills in bilingual communication. Don't let fear or inexperience hold you back."
        />
        <SkillAreas
          skillAreaTitle={skillAreaTitle}
          lifestyleCards={lifestyleCards}
          btnText={"Prepare For PTE Core Today"}
          skillSubtitle={"Attending an on-campus program can be difficult for many people with busy schedules, work commitments, or geographical constraints. Our NAATI CCL online coaching offers the perfect solution:"}
          MiddleInfoSection={[
            "NAATI CCL online classes let you hone your translation and interpretation skills with the ease of accessing the course from anywhere you want.",
            "You can easily balance your underlying commitments and NAATI CCL training by attending our online coaching sessions.",
          ]}
          skillBottomtitle="Say goodbye to unreliable self-study plans and outdated materials, our system is designed to get you results."
        />
        <div className="custom-container py-5">
          <ContentImageSection
            contentSection={contentSection}
            quoteText={
              "Struggling to find quality resources or balance your preparation with a busy schedule? You're not alone! We understand the key concerns of NAATI CCL aspirants, including:"
            }
            btnClassName="mt-2"
            image={Immigration}
            imageClassName="immigration-test-img"
            listColumns={[
              [
                "Difficulty attending on-campus courses",
                "Lack of access to reliable preparation materials",
                "Insufficient practice opportunities",
                "Fear of failing the NAATI CCL exam",
              ],
            ]}
            listBottomText="Our online coaching program is designed to eliminate these barriers, giving you the tools, support, and confidence you need to succeed."
          />
        </div>
        <SkillAreas
          className={"skill-section"}
          background={"white"}
          color={"black"}
          skillAreaTitle={skillAreaTitle2}
          lifestyleCards={styleCards}
          btnText={"Get Started With Our Online Program "}
          btnLink={() => window.location.href = `${import.meta.env.VITE_NAATI_URL}auth/register`}
          skillSubtitle={
            "At Language Academy, our NAATI CCL training preparation course curriculum includes modules strategized after carefully assessing your skills. We understand how important this course is for you to claim five additional points towards your Australian permanent residency."
          }
          skillBottomtitle="With us, your preparation journey is flexible, efficient, and results-driven."
        />

        <AppPromoSection
          titleHighlight="Language Academy"
          title="NAATI CCL Mobile Application For Comprehensive Preparation"
          subtitle="Our specialized mobile app provides complete preparation tools designed for NAATI CCL success:"
          featuresLeft={[
            {
              icon: "/images/web-new-images/yourApprochIcon.svg",
              title: "Vocabulary In 7 Different Categories",
              description: "A complete list of 2000+ words included and explained in various native languages with translations.",
            },
            {
              icon: "/images/web-new-images/yourApprochIcon.svg",
              title: "Mock Tests Like Real-Time Exam",
              description: "Experience the actual test environment to understand what to expect and how to perform optimally.",
            },
          ]}
          featuresRight={[
            {
              icon: "/images/web-new-images/yourApprochIcon.svg",
              title: "Comprehensive Practice Dialogues",
              description: "Dialogues from different categories and scenarios similar to previous exams, with 80+ practice dialogues including sample responses prepared by certified interpreters.",
            },
            {
              icon: "/images/web-new-images/yourApprochIcon.svg",
              title: "Last-Minute Preparation Package",
              description: "Short packages with expert tips to boost your confidence before the exam.",
            },
          ]}
          mobileImg="/images/web-new-images/emojis/Updated/PromoSection.png"
          ctaText="Download Our App and Start Practicing"
          onCtaClick={() => window.open(import.meta.env.VITE_NAATI_IOS_APP_URL)}
        />

        <ExamSkillsSection
          title="Master Every Aspect Of"
          highlight="NAATI CCL Exam"
          description={`To succeed in the NAATI CCL exam, you need to excel in both translation and interpretation.<br/>Here's how we help you prepare;`}
          ctaText="Sign Up For Our Prep Program Now"
          onCtaClick={() => navigate("/auth/register")}
          bottomText='Gain confidence in every skill area and deliver your best performance on exam day.'
          cards={[
            {
              icon: ListeningIcon,
              title: "Listening",
              content: `
                <div>
                <ul class='feature-list'>
                <li>
                  <strong>What It Tests</strong><br/>
                  Understanding accents, tones, and cultural nuances.<br/><br/>
                </li>
                <li>
                  <strong>Our Approach</strong><br/>
                  Audio-based exercises with a focus on improving comprehension & cultural sensitivity.
                </li>
                </ul>
                </div>
              `
            },
            {
              icon: TranslationIcon,
              title: "Translation & Interpretation",
              content: `
                <div>
                <ul class='feature-list plus-sans'>
                <li>
                  <span class='FS18FW400 fw-700'>What It Tests</span><br/>
                  <span class='FS16FW500'>Fluency, accuracy, and logical delivery in both English and your chosen language</span>
                </li>
                <li>
                  <span class='FS18FW400 fw-700'>Our Approach</span><br/>
                  <span class='FS16FW500'>Practice real-life dialogues, vocabulary building, and targeted mock tests.</span>
                </li>
                </ul>
                </div>
              `
            },
            {
              icon: TimeIcon,
              title: "Time Management",
              content: `
                <div>
                <ul class='feature-list plus-sans'>
                <li>
                  <span class='FS18FW400 fw-700'>What It Tests</span><br/>
                  <span class='FS16FW500'>Staying calm and composed under pressure to meet time constraints.</span>
                </li>
                  <li>
                    <span class='FS18FW400 fw-700'>Our Approach</span><br/>
                    <span class='FS16FW500'>Strategies to handle time efficiently during the test without compromising accuracy.</span>
                </li>
                </ul>
                </div>
              `
            }
          ]}
        />

        <ExamSkillsSection
          title="Why Choose Language Academy"
          highlight="NAATI CCL Exam"
          subtitle="Preparation"
          ctaText="Experience Our Comprehensive Approach"
          onCtaClick={() => window.location.href = `${import.meta.env.VITE_NAATI_URL}auth/register`}
          cards={[
            {
              icon: ExperiencedIcon,
              title: "Experienced Trainers",
              content: `
                <div>Our experienced trainers help you improve your translation and interpretation sections for NAATI CCL online coaching preparation.</div>
              `
            },
            {
              icon: HighestIcon,
              title: "Highest Success Rate",
              content: `
                <div>We continuously involve ourselves personally with every NAATI CCL coaching student, enabling them to unleash their potential and achieve the highest scores possible.</div>
              `
            },
            {
              icon: MaterialsIcon,
              title: "Free Study Materials",
              content: `
                <div>Every NAATI online course student gets proven templates and free material to study and understand the best approach to excel in the exam.</div>
              `
            },{
              icon: ResourceIcon,
              title: "Latest Resources",
              content: `
                <div>Students can easily access study materials and take practice tests through our NAATI CCL Online Classes mobile app with just a few taps.</div>
              `
            },{
              icon: SupportIcon,
              title: "Online Support",
              content: `
                <div>During the entire course duration, our experts are available to answer all your questions and help wherever you're stuck.</div>
              `
            },{
              icon: QuestionsIcon,
              title: "Extensive Questions to Practice",
              content: `
                <div>We have curated several previous question papers to help students practice common questions asked frequently.</div>
              `
            },{
              icon: DiscussionIcon,
              title: "Discussion Sessions",
              content: `
                <div>Our experts note student weaknesses and strengths during discussion sessions to devise personalized study plans.</div>
              `
            },{
              icon: FeeIcon,
              title: "Affordable NAATI Course Fee",
              content: `
                <div>Our costs are pocket-friendly so students can easily pay their NAATI course fee and improve their scores through our NAATI CCL training centre programs.</div>
              `
            },{
              icon: TestEnvironmentIcon,
              title: "Real-Time Test Environment",
              content: `
                <div>Our mock tests provide students with the actual experience of taking tests, allowing them to test their interpretation skills effectively.</div>
              `
            }
          ]}
        />
        <SkillAreas
          skillAreaTitle={preprationWorkTitle}
          lifestyleCards={preprationWorkCards}
          btnText2='Start Your Step-By-Step Journey'
          btnLink2={`${import.meta.env.VITE_NAATI_URL}auth/register`}
        />

        <section className="py-5">
          <div className="custom-container">

          {/* Top Row */}
          <div className="row align-items-center mb-4">
            
            {/* Left Title */}
            <div className="col-lg-6">
              <h2 className="top-section-text FS40FW600">
                Comprehensive <span className="text-success fst-italic">Practice</span><br/>
                <span className="text-success">Materials</span> For All Languages
              </h2>
            </div>

            {/* Right Content */}
            <div className="col-lg-6 text-lg-start mt-3 mt-lg-0">
              <p className="FS16FW500 fw-300 text-muted mb-3">
                Language Academy provides the best practice materials to help you achieve the 5 bonus points required for Australian PR:
              </p>
              <a href={`${import.meta.env.VITE_NAATI_URL}auth/register`} className="primary-btn px-4 py-2">
                Access Materials in Your Language <img src={`/images/web-new-images/right-arrow.svg`} alt="Register Now" />
              </a>
            </div>
          </div>

          {/* Main Content */}
          <div className="row g-4">
              {/* Left Big Card */}
              <div className="col-lg-8">
                <div className="main-card p-4 h-100">

                  <div className="d-flex align-items-center mb-3">
                    <div className="icon-circle me-2">
                      <img src={BuildingIcon} alt="icon" />
                    </div>
                    <h6 className="mb-0 fw-semibold">
                      NAATI CCL Practice Materials Available in:
                    </h6>
                  </div>

                  <hr className="main-card"/>

                  {/* Languages Grid */}
                  <div className="row g-3 mt-2">

                    {[
                      "Hindi", "Punjabi", "Urdu", "Nepali",
                      "Bangla", "Tamil", "Telugu", "Malayalam",
                      "Gujarati", "Sinhalese", "Marathi", "Kannada"
                    ].map((lang, index) => (
                      <div className="col-6 col-md-4 col-lg-3" key={index}>
                        <div className="lang-box text-center p-3">
                          <div className="small text-muted">{lang}</div>
                          <div className="fw-semibold">{lang}</div>
                        </div>
                      </div>
                    ))}

                  </div>

                </div>
              </div>

              {/* Right Side Cards */}
              <div className="col-lg-4">
                <div className="d-flex flex-column gap-4 h-100">

                  {/* Card 1 */}
                  <div className="side-card p-4">
                    <div className="icon-circle mb-2 justify-content-start">
                      <img src={DollarIcon} alt="icon" />
                    </div>
                    <span className="plus-sans FS24FW500 fw-700">NAATI CCL Vocabulary Building</span>
                    <p className="text-muted small mb-0">
                      Comprehensive vocabulary lists in all 12 supported languages
                    </p>
                  </div>

                  {/* Card 2 */}
                  <div className="side-card p-4">
                    <div className="icon-circle mb-2 justify-content-start">
                      <img src={UserIcon} alt="icon" />
                    </div>
                    <span className="plus-sans FS24FW500 fw-700">NAATI CCL Test Practice Dialogues</span>
                    <p className="text-muted small mb-0">
                      Extensive dialogue practice in Hindi, Punjabi, Urdu, Nepali, Bangla, Tamil, Telugu, Malayalam, Gujarati, Sinhalese, Marathi and Kannada.
                    </p>
                  </div>

                </div>
              </div>

            </div>

          </div>
        </section>

        <TestimonialSection
          title={`<span class="hero-title FS40FW600 text-center mb-md-0">Hear From <span class="green-text">Our Successful Students</span></span>`}
          subtitle={'Your success is our priority. Let us help you achieve your dreams!'}
          showBtn={false}
          sliderList={sliderList}
        />
        <PricingSection data={pricingSectionData} />

        {/* <PteAppBanner appName='NAATI' /> */}
          <AppBannerCustom
            appName="NAATI"
            description="LA CCL"
            mobileImage="/images/web-new-images/HomePageImage/NAATI-app.png"
            playStoreLink={`${import.meta.env.VITE_NAATI_ANDROID_APP_URL}`}
            appStoreLink={`${import.meta.env.VITE_NAATI_IOS_APP_URL}`}
          />
        <FaqSection questions={faqQuestions}/>
        <Footer />
      </div>
      <div
        className="modal fade"
        id="staticBackdrop1"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog main-popup">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">
                  <img
                    className="img-fluid"
                    src="/images/web-new-images/icons/close-icon2.svg"
                    alt="LA"
                  />
                </span>
              </button>
            </div>
            <div className="modal-body p-0">
              <div className="form-content-outer m-0">
                <div className="form-content">
                  <div className="main-popup-img form-img">
                    <img
                      className="img-fluid"
                      src="/images/web-new-images/hero_img-02.png"
                      alt="LA"
                    />
                  </div>
                  <div className="main-popup-content form-content-right">
                    <h4 className="popup-title">Take a FREE Demo Class</h4>
                    <p className="popup-sub-title">Submit Your Details Below</p>
                    <div className="pte-popup-form-start">
                      <form onSubmit={submitForm}>
                        <div className="fieldOuter">
                          <label htmlFor="name">Name*</label>
                          <div className="form-input-outer">
                            <input
                              id="name"
                              className="form-input"
                              type="text"
                              name="name"
                              placeholder="Enter Name"
                              value={name}
                              onChange={changeInput}
                            />
                          </div>
                          {validator.current.message("Name", name, "required")}
                        </div>
                        <div className="fieldOuter">
                          <label htmlFor="PhoneNumber">Phone Number</label>
                          <PhoneInputField
                            id="PhoneNumber"
                            value={phone}
                            changeEvent={handlePhoneChange}
                            addClass="popup-class"
                          />
                          {validator.current.message(
                            "phone",
                            phone,
                            "required|phone",
                          )}
                          <span className="err phone-error"></span>
                        </div>
                        <div className="fieldOuter">
                          <label htmlFor="email">Email*</label>
                          <div className="form-input-outer">
                            <input
                              id="email"
                              className="form-input"
                              type="text"
                              name="email"
                              placeholder="Enter Email"
                              value={email}
                              onChange={changeInput}
                            />
                          </div>
                          {validator.current.message(
                            "Email",
                            email,
                            "required",
                          )}
                        </div>
                        <div className="fieldOuter">
                          <label htmlFor="course">Center</label>
                          <div className="form-input-outer form-select-wrapper">
                            <select
                              id="course"
                              className="form-input"
                              name="course"
                              value={course}
                              onChange={changeInput}
                            >
                              <option value="NAATI CCL Online">
                                NAATI CCL Online
                              </option>
                              <option value="PTE On-Campus1">
                                PTE On-Campus
                              </option>
                              <option value="NAATI CCL Online">
                                PTE Online
                              </option>
                              <option value="NAATI CCL On-Campus">
                                NAATI CCL On-Campus
                              </option>
                              <option value="IELTS Online">IELTS Online</option>
                              <option value="IELTS On-Campus">
                                IELTS On-Campus
                              </option>
                            </select>
                          </div>
                        </div>
                        <div className="fieldOuter">
                          <label htmlFor="language">Language</label>
                          <div className="form-input-outer form-select-wrapper">
                            <select
                              id="lang"
                              className="form-input"
                              name="lang"
                              value={lang}
                              onChange={changeInput}
                            >
                              <option value="Hindi">Hindi</option>
                              <option value="Punjabi">Punjabi</option>
                              <option value="Urdu">Urdu</option>
                              <option value="Nepali">Nepali</option>
                              <option value="Bangla">Bangla</option>
                              <option value="Tamil">Tamil</option>
                              <option value="Telugu">Telugu</option>
                              <option value="Sinhalese">Sinhalese</option>
                              <option value="Malayalam">Malayalam</option>
                              <option value="Gujarati">Gujarati</option>
                              <option value="Kannada">Kannada</option>
                            </select>
                          </div>
                        </div>
                        <div className="fieldOuter">
                          <label htmlFor="language">Comments / Query</label>
                          <div className="form-input-outer">
                            <input
                              className="form-input"
                              type="text"
                              name="query"
                              placeholder="Enter your comments/Query"
                              value={query}
                              onChange={changeInput}
                            />
                          </div>
                          {validator.current.message(
                            "Query",
                            query,
                            "required",
                          )}
                        </div>
                        <div className="fieldOuter mb-0">
                          {!loginLock && (
                            <button
                              className="primary-btn"
                              onClick={hitApi}
                              type="button"
                            >
                              SUBMIT{" "}
                              <img
                                src="/images/web-new-images/right-arrow.svg"
                                alt="LA"
                              />
                            </button>
                          )}
                          {loginLock && (
                            <button className="themeBtn">Wait...</button>
                          )}
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
});

export default NaatiOnlineCoaching;
